import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import user from './user';
import deviceInfo from "./deviceInfo";
import loading from "./loading";
import sound from "./sound";
import asideState from "./asideState";
import aiDiagnosisTestData from "./aiDiagnosisTestData";
import learningData from "./learningData";
import mathjax from "./mathjax";
import answeringQuestions, { answeringQuestionsSaga } from "./answeringQuestions/answeringQuestions";
import answeringInfo from "./answeringQuestions/answeringInfo";
import timeCount from "./answeringQuestions/timeCount";
import questionView from "./answeringQuestions/questionView";
import keypad from "./answeringQuestions/keypad";
import notepad from "./answeringQuestions/notepad";
import answerEditor, { answerEditorSaga } from "./answeringQuestions/answerEditor";
import pmNotice from './pmNotice';
import errorState from './errorState';
import common from './common';
import logData from './logData';
import amplitudeLogData from './amplitude';
import network from './network';
import hackleClient from "./hacklecClient";

const reducers = combineReducers( {
  user,
  deviceInfo,
  loading,
  sound,
  asideState,
  aiDiagnosisTestData,
  learningData,
  mathjax,
  answeringQuestions,
  answeringInfo,
  timeCount,
  questionView,
  keypad,
  notepad,
  answerEditor,
  pmNotice,
  errorState,
  common,
  logData,
  amplitudeLogData,
  network,
  hackleClient
} );

function * saga () {

  yield all( [
    answeringQuestionsSaga(),
    answerEditorSaga()
  ] );

}

export default reducers;
export { saga };
